import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import MenuBase from '@mui/material/Menu';
import TableHeadBase from '@mui/material/TableHead';
import TableCellBase from '@mui/material/TableCell';

import { Icon } from '@components/icon';
import { Button } from '@mui/material';

export const LogoWrapper = styled(Grid).attrs({
  p: 5,
  container: true,
  justifyContent: 'center',
})`
  background: ${({ theme }) => theme.gradients.secondary};
`;

export const Menu = styled(MenuBase).attrs({})`
  &:ul {
    padding-top: 0px;
  }
`;

export const TableHead = styled(TableHeadBase).attrs({})`
  background: ${({ theme }) => theme.gradients.secondary};
`;

export const TableCellHeader = styled(TableCellBase).attrs({
  sx: {
    fontFamily: 'Mukta',
    color: '#fff',
    fontSize: 19,
    fontWeight: 400,
    padding: 0,
    borderBottom: 0,
  },
})``;

export const TableCell = styled(TableCellBase).attrs({
  sx: {
    fontFamily: 'Mukta',
    fontWeight: '400',
    color: 'text.primary',
    fontSize: 17,
    padding: 0,
  },
})``;

export const LogoIcon = styled(Icon).attrs({
  name: 'logo',
  alt: 'Logo Icone',
})<{ name?: string; alt?: string }>`
  width: 16rem;
`;

export const IconBox = styled(Box).attrs({
  paddingTop: '8px',
})`
  cursor: pointer;
`;

export const ModalContainer = styled(Box).attrs({
  sx: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 350,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 3,
    p: 4,
    py: 8,
  },
  justifyContent: 'center',
  display: 'flex',
})``;

export const ButtonYes = styled(Button).attrs({
  sx: {
    mt: 3,
    mb: 2,
    fontWeight: 700,
    fontSize: 16,
    color: 'white.main',
    fontFamily: 'Mukta',
  },
})`
  background: ${({ theme }) => theme.gradients.primary};
`;

export const ButtonNo = styled(Button).attrs({
  sx: {
    mt: 3,
    mb: 2,
    fontWeight: 700,
    fontSize: 16,
    color: 'black.main',
    fontFamily: 'Mukta',
  },
})`
  border: 1px solid rgba(165, 16, 51, 1) !important;
  color: gray;
`;

export const ButtonContainer = styled(Box).attrs({
  display: 'flex',
  gap: '24px',
})``;
